import { useNavigate } from "react-router";
import { useLocalStorage } from "usehooks-ts";
import { SpinnerLegacy } from "../../../components";
import { IntersectingInfiniteLoadingButton } from "../../../components/infiniteLoading/IntersectingInfiniteLoadingButton";
import { defaultLondonLocation } from "../../../components/map/SellarMap.shared";
import { NavigationBar } from "../../../components/navigation/NavigationBar";
import { DISCOVER, ORDER_BUYER } from "../../../constants/routes";
import { useSupplierListByDistance } from "../../../hooks/api/v2/supplier/useSupplierListByDistance";
import { useNavigateToChild } from "../../../hooks/useParentNavigation";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { DiscoveryListSupplierCard } from "./DiscoveryListSupplierCard";

export const DiscoveryV2SuppliersDirectList = () => {
  const navigate = useNavigate();
  const navigateToChild = useNavigateToChild();
  const [unAuthorisedUserPostcode] = useLocalStorage<string | undefined>(
    "unauthorisedUserPostcode",
    undefined,
  );
  const [unAuthorisedUserLocation] = useLocalStorage<
    { lat: number; lng: number } | undefined
  >("unAuthorisedUserLocation", undefined);

  const { business } = useSellarCurrentBusiness();
  const directSuppliersQuery = useSupplierListByDistance({
    offset: 0,
    limit: 20,
    lng:
      business?.Location?.lng ??
      unAuthorisedUserLocation?.lng ??
      defaultLondonLocation.lng,
    lat:
      business?.Location?.lat ??
      unAuthorisedUserLocation?.lat ??
      defaultLondonLocation.lat,
    distance: 10_000,
    unAuthorisedUserPostcode,
    orderBy: "distance",
    directDelivery: true,
  });

  const postcode =
    business?.DeliveryAddress.postalCode.split(" ")[0] ??
    unAuthorisedUserPostcode?.split(" ")[0] ??
    undefined;

  const suppliers =
    directSuppliersQuery.data?.pages.flatMap((page) => page) ?? [];

  const { isLoading } = directSuppliersQuery;
  if (isLoading) return <SpinnerLegacy />;

  return (
    <>
      <NavigationBar
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => {
          navigate(DISCOVER);
        }}
        title={`Suppliers delivering direct${postcode ? ` to ${postcode}` : ""}`}
      />
      <div className="m-auto flex w-[100vw] max-w-[1200px] flex-col gap-4 p-4 transition-opacity min-[640px]:w-[88vw] min-[1280px]:w-[79vw] md:pt-10">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {suppliers.map((supplier) => (
            <DiscoveryListSupplierCard
              key={supplier.id}
              supplier={supplier}
              onClick={() =>
                navigateToChild(
                  ORDER_BUYER.href({ supplierIdOrUrlId: supplier.urlId }),
                )
              }
            />
          ))}
        </div>
        <IntersectingInfiniteLoadingButton query={directSuppliersQuery} />
      </div>
    </>
  );
};
